import { render } from "./ToggleViewButton.vue?vue&type=template&id=010f64be&scoped=true"
import script from "./ToggleViewButton.vue?vue&type=script&lang=js"
export * from "./ToggleViewButton.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-010f64be"

export default script